import { render, staticRenderFns } from "./SupplierGeneralFirstInfo.vue?vue&type=template&id=48355504&scoped=true&"
import script from "./SupplierGeneralFirstInfo.vue?vue&type=script&lang=js&"
export * from "./SupplierGeneralFirstInfo.vue?vue&type=script&lang=js&"
import style0 from "./SupplierGeneralFirstInfo.vue?vue&type=style&index=0&id=48355504&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48355504",
  null
  
)

export default component.exports